import styled from "styled-components";

export const Handle = styled.span`
  /* Controle interativo: fora da captura html2canvas. A barrinha do ::after
     e permanente (opacidade 0.5) e o export-mode ainda a levava a 1, entao
     saia como um risco em cada divisa de coluna na imagem. */
  body[data-export-mode="true"] & {
    display: none;
  }

  position: absolute;
  top: 0;
  right: -3px;
  width: 7px;
  height: 100%;
  cursor: col-resize;
  user-select: none;
  z-index: 3;
  touch-action: none;

  /* Bloco TBL.3 (2026-05-25) — Handle estilo Notion:
   * - barra fina cinza PERMANENTE (1px, opacidade 0.5) — sempre visivel
   *   no header da tabela, dando dica visual de que coluna pode ser
   *   redimensionada sem precisar "cacar" o cursor;
   * - cor accent + barra mais grossa (3px) on hover/drag — feedback
   *   forte quando usuario interage;
   * - hit-area continua 7px (Handle wrapper inteiro) — area clicavel
   *   maior que o visual permite "pegar" facilmente. */
  &::after {
    content: "";
    position: absolute;
    top: 15%;
    right: 3px;
    width: 1px;
    height: 70%;
    background: ${({ theme }) => theme.border};
    opacity: 0.5;
    border-radius: 1px;
    transition: background 0.12s ease, width 0.12s ease, opacity 0.12s ease;
  }

  &:hover::after,
  &[data-dragging="true"]::after {
    background: ${({ theme }) => theme.accent};
    width: 3px;
    opacity: 1;
  }
`;

export const ResetButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.textSecondary};
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.accent};
    color: ${({ theme }) => theme.accent};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  /* Controle interativo: fora da captura html2canvas. Estava saindo como um
     botão circular solto no canto superior direito da imagem (Terceiros,
     Acabamento, Marcenaria). Não usar opacity aqui — GlobalStyles força
     opacity: 1 !important em modo export e anularia a regra. */
  body[data-export-mode="true"] & {
    display: none;
  }
`;
